/**
 * Numbers in the interface (GDD §12, §13.1): always grouped with a dot, also with four digits ("1.250").
 * Intl.NumberFormat('es-ES') does not group four-digit numbers, so the grouping is done here. Shared with
 * the HUD readouts (#58).
 */
export function formatNumber(value: number): string {
  const sign = value < 0 ? '-' : '';
  const digits = String(Math.trunc(Math.abs(value)));
  return sign + digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/** A counter with a fixed number of digits, "FAJOS 007" (GDD §13.3); negative values are rejected. */
export function padDigits(value: number, digits: number): string {
  if (value < 0) throw new RangeError(`padDigits needs a non-negative number, got ${value}`);
  return String(Math.trunc(value)).padStart(digits, '0');
}

/** Dates of the dossiers as AAAA-MM-DD, in the expediente voice. */
export function formatDate(iso: string): string {
  return iso.slice(0, 10);
}
